import { FC, ForwardedRef, forwardRef } from "react";
import { Minus, Plus } from "theme/icons";

import {
  NumberInputProps,
  Unstable_NumberInput as BaseNumberInput,
} from "@mui/base/Unstable_NumberInput";
import { styled } from "@mui/system";

const NumberInput = forwardRef(function CustomNumberInput(
  props: NumberInputProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <BaseNumberInput
      slots={{
        root: StyledInputRoot,
        input: StyledInput,
        incrementButton: StyledButton,
        decrementButton: StyledButton,
      }}
      slotProps={{
        incrementButton: {
          children: <Plus />,
          className: "increment",
          style: {
            background: "none",
          },
        },
        decrementButton: {
          children: <Minus />,
          style: {
            background: "none",
          },
        },
        input: {
          disabled: true,
          style: {
            color: "#000",
          },
        },
        root: {
          onClick: (e) => {
            e.preventDefault();
          },
        },
      }}
      {...props}
      ref={ref}
    />
  );
});

type CounterProps = {
  maxValue: number;
  value: number | null;
  onChange: (value: number | null) => void;
};

const Counter: FC<CounterProps> = ({ maxValue, value, onChange }) => {
  return (
    <NumberInput
      aria-label="Quantity Input"
      min={1}
      value={value}
      onChange={(_, v) => onChange(v)}
      max={maxValue}
    />
  );
};

export default Counter;

const StyledInputRoot = styled("div")(
  () => `
  font-family: 'Ttnorms', sans-serif;
  font-weight: 400;
  display: flex;
  border: 1px solid #000;
  border-radius: 20px;
  padding: 4px 10px;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`,
);

const StyledInput = styled("input")(
  () => `
  font-size: 0.875rem;
  font-family: inherit;
  border: none;
  background: none;
  font-weight: 500;
  line-height: 1.375;
  outline: 0;
  min-width: 0;
  width: 29px;
  text-align: center;

  &:focus-visible {
    outline: 0;
  }
`,
);

const StyledButton = styled("button")(
  () => `
  font-family: 'Ttnorms', sans-serif;
  box-sizing: border-box;
  line-height: 1;
  border: none;
  width: 24px;
  height: 24px;
  display: flex;
  padding: 0;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;
  
  &:disabled{
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`,
);
